import { render, staticRenderFns } from "./_Tabs.vue?vue&type=template&id=4d689035&scoped=true&"
import script from "./_Tabs.vue?vue&type=script&lang=js&"
export * from "./_Tabs.vue?vue&type=script&lang=js&"
import style0 from "./_Tabs.vue?vue&type=style&index=0&id=4d689035&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d689035",
  null
  
)

export default component.exports